module.exports = __webpack_public_path__ + "static/media/pdf.721fa46f.svg";